module.exports = __webpack_public_path__ + "static/img/f-biotic-logo-1.0311eedb.jpg";